var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgServices(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 19,
    fill: "none",
    viewBox: "0 0 21 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5996 2.59961H19.5996M11.5996 6.59961H16.5996M11.5996 12.5996H19.5996M11.5996 16.5996H16.5996M2.59961 1.59961H6.59961C7.15189 1.59961 7.59961 2.04732 7.59961 2.59961V6.59961C7.59961 7.15189 7.15189 7.59961 6.59961 7.59961H2.59961C2.04732 7.59961 1.59961 7.15189 1.59961 6.59961V2.59961C1.59961 2.04732 2.04732 1.59961 2.59961 1.59961ZM2.59961 11.5996H6.59961C7.15189 11.5996 7.59961 12.0473 7.59961 12.5996V16.5996C7.59961 17.1519 7.15189 17.5996 6.59961 17.5996H2.59961C2.04732 17.5996 1.59961 17.1519 1.59961 16.5996V12.5996C1.59961 12.0473 2.04732 11.5996 2.59961 11.5996Z",
    stroke: "#1B1B20",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices);
export default __webpack_public_path__ + "static/media/services.e6112043.svg";
export { ForwardRef as ReactComponent };